import React, {useState} from "react";

import icon_directory from "./../../../sources/icons/icon-directory.svg";
import icon_directory_pink from "./../../../sources/icons/icon-directory-pink.svg";

//Herramientas
import PRIVILEGIO_01 from "./tools/PRIVILEGIO_01";
import PRIVILEGIO_02 from "./tools/PRIVILEGIO_02";
import PRIVILEGIO_03 from "./tools/PRIVILEGIO_03";
import STEGHIDE from "./tools/STEGHIDE";

export default function Provilegios (props) {

    const [herramienta, setHerramienta] = useState(1)

    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Fase Mantenimiento de Acceso y Escalada de Privilegios.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                A <span className="span-white">continuacion,</span> se muestra la <span className="span-white">lista</span> de <span className="span-pink">herramientas</span> para el  <span className="span-white">Paso del Haking </span> <span className="span-yellow">Fase de Mantenimiento de Acceso y Escalada de Privilegios:</span>
            </p>

            <p>
                (<i className="span-yellow">Selecciona</i> una <span className="span-white">herramienta</span> para <span className="span-white">visualizar</span> su <span className="span-pink">documentación</span> e <span className="span-pink">información</span>).
            </p>

            <div className="div-structure-row">
                <a className="a-structure" onClick={() => setHerramienta(1)}>
                    <h3 className="span-blue">
                        <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                        <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN RUTA DE ARRANQUE.<span className="span-pink cursor">_</span>
                        </span>
                    </h3>
                </a>

                <a className="a-structure" onClick={() => setHerramienta(2)}>
                    <h3 className="span-blue">
                        <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                        <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN MODIFICACIÓN DE REGISTRO.<span className="span-pink cursor">_</span>
                        </span>
                    </h3>
                </a>

                <a className="a-structure" onClick={() => setHerramienta(3)}>
                    <h3 className="span-blue">
                        <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                        <span className="span-pink"> MANTENIMIENTO DE ACCESO POR ARCHIVO EN TAREA PROGRAMADA.<span className="span-pink cursor">_</span>
                        </span>
                    </h3>
                </a>

                <a className="a-structure" onClick={() => setHerramienta(4)}>
                    <h3 className="span-blue">
                        <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                        <span className="span-pink"> STEGHIDE.<span className="span-pink cursor">_</span>
                        </span>
                    </h3>
                </a>
            </div>

            <hr className="cursor"/>

            <p>
                A <span className="span-pink">continuación</span>, la <span className="span-white">documentación</span> e <span className="span-white">información</span> de la <i className="span-yellow">herramienta</i>:
            </p>

            {(() => {
                            if (herramienta === 1) {
                                return <PRIVILEGIO_01
                                    funcionNotificacion = {props.funcionNotificacion}
                                    notifications = {props.notifications}
                                />;
                            } else if (herramienta === 2) {
                                return <PRIVILEGIO_02
                                funcionNotificacion = {props.funcionNotificacion}
                                notifications = {props.notifications}
                                />;
                            } else if (herramienta === 3) {
                                return <PRIVILEGIO_03
                                funcionNotificacion = {props.funcionNotificacion}
                                notifications = {props.notifications}
                                />;
                            } else if (herramienta === 4) {
                                return <STEGHIDE
                                funcionNotificacion = {props.funcionNotificacion}
                                notifications = {props.notifications}
                                />;
                            } else {
                                return <PRIVILEGIO_01
                                    funcionNotificacion = {props.funcionNotificacion}
                                    notifications = {props.notifications}
                                />;
                            }
                        })()}
        </>
    );
}